import RequestAdapterService from './request-adapter';

export default class ReferralService extends RequestAdapterService {
	async createReferralCode() {
		try {
			const { data } = await super.sendPostRequest(
				`${this.baseUrl}/referral/create`
			);

			return data;
		} catch (error) {
			console.error(error);
			throw new Error(
				`Create Referral Code Failed: ${super.generateErrorMessage(error)} \n
				${error?.response?.status} - ${
					error.response.data.errors
						? error.response.data.errors.code
						: 'Error'
				} `
			);
		}
	}

	async saveMyCardInfo(cardInfo) {
		try {
			const { data } = await super.sendPostRequest(
				`${this.baseUrl}/card-bank/save`,
				cardInfo
			);

			return data;
		} catch (error) {
			console.error(error);
			throw new Error(
				`Save Card Info Failed: ${super.generateErrorMessage(error)} \n
				${error?.response?.status} - ${
					error.response.data.errors
						? error.response.data.errors.code
						: 'Error'
				} `
			);
		}
	}

	async getMyBalance() {
		try {
			const {
				data: { data },
			} = await super.sendGetRequest(
				`${this.baseUrl}/referral/balance`
			);

			return data;
		} catch (error) {
			throw new Error(error);
		}
	}

	async getListBank() {
		try {
			const {
				data: { data },
			} = await super.sendGetRequest(
				`${this.baseUrl}/bank`
			);

			return data;
		} catch (error) {
			throw new Error(error);
		}
	}

	async getMyCard() {
		try {
			const {
				data: { data },
			} = await super.sendGetRequest(
				`${this.baseUrl}/card-bank`
			);

			return data;
		} catch (error) {
			throw new Error(error);
		}
	}

	async getInfoReferral() {
		try {
			const {
				data: { data },
			} = await super.sendGetRequest(
				`${this.baseUrl}/referral/show`
			);

			return data;
		} catch (error) {
			throw new Error(error);
		}
	}

	async detailWithdrawal(params) {
		try {
			const {
				data: { data },
			} = await super.sendGetRequest(
				`${this.baseUrl}/referral/withdraws/show`,
				params
			);

			return data;
		} catch (error) {
			throw new Error(error);
		}
	}

	async getWithdrawalHistory() {
		try {
			const {
				data: { data },
			} = await super.sendGetRequest(
				`${this.baseUrl}/referral/withdraws/history`
			);

			return data;
		} catch (error) {
			throw new Error(error);
		}
	}

	async requestWithdraws(cardInfo) {
		try {
			const { data } = await super.sendPostRequest(
				`${this.baseUrl}/referral/withdraws/request`,
				cardInfo
			);

			return data;
		} catch (error) {
			console.error(error);
			throw new Error(
				`Request Withdrawal Failed: ${super.generateErrorMessage(error)} \n
				${error?.response?.status} - ${
					error.response.data.errors
						? error.response.data.errors.code
						: 'Error'
				} `
			);
		}
	}

	async getListReferralTransaction() {
		try {
			const {
				data: { data },
			} = await super.sendGetRequest(
				`${this.baseUrl}/referral/transaction`
			);

			return data;
		} catch (error) {
			throw new Error(error);
		}
	}

}
